import React from "react";
import { useState } from "react";
import { WalletController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { OutflowReviewModal } from "../../pages";
import { date, object, string } from "yup";
import { walletStore } from "../../stores";

const OutflowReviewModalContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return object({
      action: string().required("Please select an action"),
    });
  };

  const outflowData = walletStore.outflowData;

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      Id: outflowData._id,
      action: values.action,
    };

    const { status, errorMessage } =
      await WalletController.reviewOutflow(payload);

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({ message: status });
      return closeModal();
    }

    setLoading(false);
    return MimaToastUtil.error({ message: errorMessage });
  };

  return (
    <OutflowReviewModal
      onSubmit={onSubmit}
      closeModal={closeModal}
      loading={loading}
      validationSchema={validationSchema}
      outflowData={outflowData}
    />
  );
};
export default OutflowReviewModalContainer;
